import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

/**
 * Inline banner shown when an action was blocked by tier limits (the backend
 * returned a 402 plan_limit_reached). Can be used in place of plain toast when
 * we want to nudge the user toward /pricing.
 */
export default function UpgradeBanner({ message, compact = false }) {
    return (
        <div
            data-testid="upgrade-banner"
            className={`journal-card border-2 border-[var(--vm-accent)]/40 flex items-center gap-3 ${compact ? "p-3" : "p-4"}`}
        >
            <Sparkles className="w-5 h-5 text-[var(--vm-accent)] shrink-0" strokeWidth={1.5} />
            <div className="flex-1 min-w-0 text-sm text-[var(--vm-text-secondary)]">
                {message || "Upgrade to rooteed Plus to unlock more of your garden."}
            </div>
            <Link
                to="/pricing"
                data-testid="upgrade-banner-cta"
                className="shrink-0 text-sm font-medium text-[var(--vm-accent)] hover:text-[var(--vm-accent-hover)] inline-flex items-center gap-1"
            >
                Go Plus <ArrowRight className="w-3 h-3" />
            </Link>
        </div>
    );
}

/**
 * Helper to parse a 402 plan_limit_reached response into a message string.
 */
export function upgradeMessageFrom(error) {
    const detail = error?.response?.data?.detail;
    if (detail && typeof detail === "object" && detail.code === "plan_limit_reached") {
        return detail.message;
    }
    return null;
}
